export default __webpack_public_path__ + "static/media/DNo.25-3.fe5ddca4.jpg";